module.exports = __webpack_public_path__ + "img/list-read.6bba4ead.png";